<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>订单中心</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <el-card shadow="hover">
      <el-form :inline="true" size="small" v-model="listQuery">
        <el-form-item label="城市">
          <el-select v-model="listQuery.cityId" clearable placeholder="请选择城市" filterable @change="cityChange2">
            <el-option v-for="(item,index) in cityList" :key="index" :label="item.cityName"
                       :value="item.id+''"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="服务站">
          <el-select v-model="listQuery.stationId" clearable placeholder="请选择服务站" filterable>
            <el-option v-for="(item,index) in queryStationList" :key="index" :label="item.stationName"
                       :value="item.id+''"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="订单状态">
          <el-select v-model="listQuery.orderStatus" clearable placeholder="请选择" filterable>
            <el-option v-for="(item,index) in orderStatusMap" :key="index" :label="item" :value="index"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="订单类型">
          <el-select v-model="listQuery.orderType" clearable placeholder="请选择" filterable>
            <el-option v-for="(item,index) in orderTypeMap" :key="index" :label="item" :value="index"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="仅查询加盟商">
          <el-select  v-model="listQuery.isFra" clearable placeholder="请选择" filterable>
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="订单编号">
          <el-input v-model="listQuery.orderNo" placeholder="订单编号" clearable></el-input>
        </el-form-item>
        <el-form-item label="加盟商名称">
          <el-input v-model="listQuery.fraName" placeholder="加盟商名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="服务者编号">
          <el-input v-model="listQuery.workerNo" placeholder="请输入" clearable></el-input>
        </el-form-item>
        <el-form-item label="收货人姓名">
          <el-input v-model="listQuery.receiverName" placeholder="请输入收货人姓名" clearable></el-input>
        </el-form-item>
        <el-form-item label="收货人电话">
          <el-input v-model="listQuery.receiverPhone" placeholder="请输入收货人电话" clearable></el-input>
        </el-form-item>

        <el-form-item label="创建时间">
          <el-date-picker format="yyyy-MM-dd" value-format="yyyy-MM-dd" v-model="listQuery.createTime" type="daterange"
                          range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                          :picker-options="pickerOptions"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-search" type="primary" plan @click="querySearch">查询</el-button>
          <el-button icon="el-icon-plus" type="primary" plan @click="addOrder" v-per="'createWmsOrder'">创建订单
          </el-button>
          <el-button icon="el-icon-plus" type="primary" plan @click="orderExport">订单信息导出</el-button>
        </el-form-item>
        <br/>
      </el-form>
      <!-- 列表数据 -->
      <el-table :data="listData" border style="width: 100%" class="table">
        <el-table-column prop="id" label="ID" width="50px" fixed="left"></el-table-column>
        <el-table-column prop="orderNo" label="订单编号" fixed="left" width="200px">
          <template slot-scope="scope">
            <el-button type="text" @click="toHandleShipment(scope.row)" size="mini">{{ scope.row.orderNo }}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="fraName" label="加盟商"  ></el-table-column>
        <el-table-column prop="payId" label="微信交易凭证"></el-table-column>
        <el-table-column prop="orderAmount" label="订单总金额"></el-table-column>
        <el-table-column prop="deposit" label="押金"></el-table-column>
        <el-table-column prop="payAmount" label="支付金额"></el-table-column>
        <el-table-column prop="orderType" label="订单类型">
          <template slot-scope="scope">
            {{ orderTypeMap[scope.row.orderType] }}
          </template>
        </el-table-column>
        <el-table-column prop="orderStatus" label="状态">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status==1?'success':'danger'"> {{ orderStatusMap[scope.row.orderStatus] }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="stockOrderStatus" label="出入库单状态">
          <!-- 1待处理，2处理中，3已完成，4取消拒绝 -->
           <template slot-scope="scope">
            <el-tag :type="scope.row.stockOrderStatus==3?'success':(scope.row.stockOrderStatus==4?'danger':'warning')"> {{ scope.row.stockOrderStatus==1?'待处理':(scope.row.stockOrderStatus==2?'处理中':(scope.row.stockOrderStatus==3?'已完成':(scope.row.stockOrderStatus==4?'取消拒绝':''))) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="outMode" label="收货方式">
          <template slot-scope="scope">
            <span>{{ outModeMap[scope.row.outMode] }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="receiverName" label="收货人姓名"></el-table-column>
        <el-table-column prop="receiverPhone" label="收货人电话"></el-table-column>
        <el-table-column prop="address" label="收货人地址"></el-table-column>
        <el-table-column prop="shipmentNumber" label="物流单号"></el-table-column>
        <el-table-column prop="payTime" :formatter="dateFormatA" label="支付时间"></el-table-column>
        <el-table-column prop="createTime" :formatter="dateFormatA" label="下单时间"></el-table-column>
        <el-table-column prop="cancelTime" :formatter="dateFormatA" label="取消时间"></el-table-column>
        <el-table-column prop="cancelReason" label="取消原因"></el-table-column>
        <el-table-column prop="createUserName" label="代下单人"></el-table-column>
        <el-table-column label="操作" fixed="right" width="200">
          <template slot-scope="scope">
            <el-button type="text" @click="toInfo(scope.row)" size="mini">详情</el-button>
            <el-button @click="batchRebuyPre(scope.row.id)"  v-if='!scope.row.orderNo.startsWith("FRA")'> 批量重买</el-button>
            <el-button type="text" plain v-per="'refundcheck'"
                       v-if="scope.row.orderStatus==4&&scope.row.auditStatus===0&&!scope.row.orderNo.startsWith('FRA')" @click="auditRefund(scope.row)"
                       size="mini">
              审核退款
            </el-button>
            <el-button type="primary" plain v-if="scope.row.orderStatus==0&&!scope.row.orderNo.startsWith('FRA')" @click="toPay(scope.row)" size="mini"
                       v-per="'payWmsOrder'">支付
            </el-button>
            <el-button type="warning" plain v-if="scope.row.orderStatus==0&&!scope.row.orderNo.startsWith('FRA')" @click="toCancel(scope.row)" size="mini"
                       v-per="'cancelWmsOrder'">取消
            </el-button>
            <el-button type="warning" plain v-if="scope.row.orderStatus==1&&scope.row.orderNo.startsWith('FRA')" @click="toInput(scope.row)" size="mini"
            >录入或修改物流单号
            </el-button>
            <el-button type="denger" plain v-if="scope.row.orderStatus==1&&scope.row.orderNo.startsWith('FRA')" @click="goRefund(scope.row)" size="mini"
            >加盟商订单退款
            </el-button>
            <!-- <el-button type="text" @click="toCancel(scope.row)" size="mini">查看租赁单</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <pagination :total="total" :page.sync="listQuery.pageNum" :limit.sync="listQuery.pageSize"
                  @pagination="querySearch"/>

    </el-card>
    <el-dialog title="批量重买" :visible.sync="isShowRebuy"  :close-on-click-modal="false" center>
      <el-form :inline="true">
        <el-row>
          <el-col :span="12">
            <el-form-item label="城市" prop="cityId">
              <el-select v-model="orderForm.cityId" clearable placeholder="请选择城市" @change="cityChange">
                <el-option v-for="(item,index) in cityList" :key="index" :label="item.cityAddress"
                           :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="服务站" prop="stationId">
              <el-select v-model="orderForm.stationId" clearable placeholder="请选择服务站" @change="stationChange2">
                <el-option v-for="(item,index) in stationList2" :key="index" :label="item.stationName"
                           :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="服务者" prop="workerNo">
              <el-select v-model="orderForm.workerNoList" clearable multiple placeholder="请选择服务者" filterable>
                <el-option v-for="(item,index) in workerList" :key="index" :label="item.workerName"
                           :value="item.workerNo"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <center>
            <el-button type="primary" plain @click="toBatchRebuy" size="mini">确定
            </el-button>
          </center>
        </el-row>
        <el-divider></el-divider>
        <el-row>
          <el-table :data="rebuyFailLis" border style="width: 100%">
            <el-table-column prop="workerNo" label="服务者编号"></el-table-column>
            <el-table-column prop="workerName" label="服务者"></el-table-column>
            <el-table-column prop="failReason" label="失败原因"></el-table-column>
            <el-table-column prop="houseId" label="仓库id"></el-table-column>
            <el-table-column prop="houseName" label="仓库"></el-table-column>
          </el-table>
        </el-row>
      </el-form>
    </el-dialog>

    <el-dialog title="支付" :visible.sync="isShowPay" width="400px" :close-on-click-modal="false" center>
      <el-form :inline="true">
        <el-form-item label="支付金额">
          <el-input v-model="tempRow.orderAmount" disabled></el-input>
        </el-form-item>
        <el-form-item label="支付类型">
          <el-select v-model="payData.payType" clearable placeholder="请选择" filterable>
            <el-option v-for="(item,index) in payType" :key="index" :label="item" :value="index"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
                <el-button @click="isShowPay=false">关闭</el-button>
                <el-button type="primary" @click="confirmPay">确定</el-button>
            </span>
    </el-dialog>

    <el-dialog title="取消" :visible.sync="isShowCancel" width="400px" :close-on-click-modal="false" center>
      <el-form :inline="true">
        <el-form-item label="订单金额">
          <el-input v-model="tempRow.orderAmount" disabled></el-input>
        </el-form-item>
        <el-form-item label="取消原因">
          <el-input type="textarea" :rows="3" v-model="cancelData.cancelReason" placeholder="取消原因"
                    clearable></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
                <el-button @click="isShowCancel=false">关闭</el-button>
                <el-button type="primary" @click="confirmCancelPay">确定</el-button>
            </span>
    </el-dialog>

    <el-dialog title="录入物流单号" :visible.sync="isShowInput" width="400px" :close-on-click-modal="false" center>
      <el-form :inline="true">
        <el-form-item label="物流单号">
          <el-input v-model="tempInput.logisticsNo" placeholder="请输入物流单号"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
                <el-button @click="isShowInput=false">关闭</el-button>
                <el-button type="primary" @click="confirmInput">确定</el-button>
            </span>
      </el-dialog>

      <el-dialog title="退款金额" :visible.sync="showRefund" width="500px" :close-on-click-modal="false" center>
      <el-form  >
        <el-form-item label="退款原因">
          <el-input v-model="refundForm.reason" placeholder="请输入退款原因" ></el-input>
        </el-form-item>
        <el-form-item label="退款金额">
          <el-input v-model="refundForm.refundAmount"   type="number" placeholder="请输入退款金额"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
                <el-button @click="showRefund=false">关闭</el-button>
                <el-button type="primary" @click="confirmRefund">确定</el-button>
            </span>
      </el-dialog>

    <el-dialog title="详情" :visible.sync="isShowDetail" width="800px" :close-on-click-modal="false" center>
      <!-- <el-table :data="orderInfo.goodsList" border class="table" max-height="320" ref="multipleTable">  -->
      <el-table :data="orderDetailList" border class="table" max-height="320" ref="multipleTable">
        <el-table-column prop="package" label="商品类型" width="100" fixed="left">
          <template slot-scope="scope">
            <span v-if="scope.row.commodityType=='套餐'" style="color:red;">套餐</span>
            <span v-if="scope.row.commodityType=='单品'" style="color:blue;">单品</span>
          </template>
        </el-table-column>
        <el-table-column prop="commodityName" label="商品"></el-table-column>
        <el-table-column prop="spuCode" label="商品SPU编码"></el-table-column>
        <el-table-column prop="skuCode" label="商品SKU编码"></el-table-column>
        <el-table-column prop="salePrice" label="销售价(元)"></el-table-column>
        <el-table-column prop="attribute" label="规格" width="280px">
          <template slot-scope="scope" v-if="scope.row.attribute" >
            <p  v-for="(item,index) in scope.row.attribute.split('<br/>')" :key="index">{{ item }}</p>
          </template>

        </el-table-column>
        <el-table-column prop="buyNumber" label="数量"></el-table-column>
        <!-- <el-table-column prop="commodityName" label="商品和规格">
            <template slot-scope="scope">
                <template v-for="item in scope.row.mydata">
                    <span :key="item.id">
                        {{item.commodityName}} ({{item.propertyValue}})
                        <span v-if="scope.row.myCurr.type==1">(数量*{{getBomListNumber(scope.row.myCurr.bomList,item.spuInfo.id)}})</span>
                        <br /></span>
                </template>
            </template>
        </el-table-column> -->
        <!-- <el-table-column prop="skuName" label="商品名称"></el-table-column>
       <el-table-column prop="skuCode" label="商品SKU编码"></el-table-column>
        <el-table-column prop="snCode" label="商品SN编码"></el-table-column>
      <el-table-column label="数量" prop="buyNumber" >  </el-table-column>
      <el-table-column prop="buyPrice" label="售卖单价"></el-table-column>
       <el-table-column prop="rentPrice" label="租赁价"></el-table-column>  -->

      </el-table>
      <span slot="footer" class="dialog-footer">
                <el-button @click="isShowDetail=false">关闭</el-button>
            </span>
    </el-dialog>

    <el-dialog title="审核退款" :visible.sync="isShowAudit" width="600px" :close-on-click-modal="false" center>
      <el-table :data="orderInfo.goodsList" border style="width: 100%" class="table">

        <el-table-column prop="skuId" label="商品skuId"></el-table-column>
        <el-table-column prop="skuName" label="商品名"></el-table-column>
        <el-table-column prop="attributes" label="规格"></el-table-column>
        <el-table-column prop="buyNumber" label="购买数量"></el-table-column>
        <el-table-column label="购买时间">
          <template>{{ orderInfo.goodsList.createTime | formatDate }}</template>
        </el-table-column>
      </el-table>
      <el-form ref="applyAuditForm" :rules="applyAuditRules" label-width="100px" :model="applyAuditForm" size="medium"
               style="padding: 40px 40px 20px">
        <el-row>
          <el-form-item label="审核状态" prop="auditStatus">
            <el-select v-model="applyAuditForm.auditStatus" placeholder="请选择审核状态">
              <el-option label="审核通过" :value="1"></el-option>
              <el-option label="审核不通过" :value="2"></el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="备注" v-if="applyAuditForm.auditStatus===2" prop="auditRemark">
            <el-input type="textarea" style="width:400px" :rows="3" placeholder="请输入备注"
                      v-model="applyAuditForm.auditRemark"></el-input>
          </el-form-item>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
                <el-button @click="isShowAudit= false">取 消</el-button>
                <el-button type="primary" @click="judgeOrderRefund()">确 定</el-button>
            </span>
    </el-dialog>


    <!--创建订单 -->
    <addOrderForm ref="addOrderFormRef"/>

  </div>

</template>
<script>
import moment from "moment";
import Pagination from "../common/Pagination";
import wmsApi from "@/script/api/wmsApi";
import globalData from "@/components/common/globaldata/global.data.vue";
import addOrderForm from "./components/addOrderForm.vue";
import "./css/index.css";
import url from "@/script/baseUrl.js";
import Service from "@/script/api/service";

export default {
  components: {Pagination, addOrderForm},
  filters: {
    formatDate(time) {
      return moment(time).format("YYYY-MM-DD");
    }
  },
  data() {
    return {
      isShowInput:false,
      tempInput:{logisticsNo:"",orderId:null},
      tempRow: {},
      isShowPay: false,
      isShowCancel: false,
      isShowDetail: false,
      isShowAudit: false,
      isShowRebuy: false,
      orderDetailList: [],
      showRefund:false,
      refundForm:{
        orderId:'',
        reason:'',
        refundAmount:'',
        fraId:''
      },
      orderInfo: {
        order: {},
        goodsList: [{
          createTime: "",
          skuId: "",
          skuName: "",
          attributes: "",
          buyNumber: "",
          buyPrice: "",
          rentPrice: ""
        }],
        lease: {},
      },
      payData: {
        orderId: null,
        payType: null,
      },
      cancelData: {
        orderId: null,
        cancelReason: null,
      },
      outModeMap: {
        1: "邮寄",
        2: "货拉拉",
        3: "现场领取",
      },
      payType: {
        1: "工资扣除",
        2: "现金支付",
        3: "支付宝",
        4: "微信",
      },
      orderStatusMap: {
        0: "未支付",
        1: "已支付",
        2: "已取消",
        3: "已退款",
        4: "待退款"
      },
      orderTypeMap: {
        1: "购买",
        2: "租赁",
        3: "领用",
      },
      total: 0,
      listData: [],
      listQuery: {
        createTime: [],
        pageNum: 1,
        pageSize: 10,
        cityId: null,
        stationId: null,
        endTime: null,
        startTime: null,
        orderStatus: null,
        orderType: null,
        orderNo: null,
        receiverName: null,
        receiverPhone: null,
        workerNo: this.$route.query.workerNo,
        isFra:null,
        fraName:null
      },
      orderForm: {
        cityId: null,
        stationId: null,
        workerNoList: []
      },
      rebuyFailLis: [],
      workerList: [],
      stationList2: [],
      cityList: [],
      stationList: [],
      queryStationList: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(
                start.getTime() - 3600 * 1000 * 24 * 7
              );
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近半个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(
                start.getTime() - 3600 * 1000 * 24 * 15
              );
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(
                start.getTime() - 3600 * 1000 * 24 * 30
              );
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      applyAuditForm: {
        orderId: null,
        auditStatus: 1,
        auditRemark: "",
      },
      applyAuditRules: {
        auditStatus: [
          {
            required: true,
            message: "请选择审核状态",
            trigger: "change",
          },
        ],
        auditRemark: [
          {
            required: true,
            message: "请输入备注",
            trigger: "change",
          },
        ],
      },
    };
  },
  created() {
    this.getAllStationList();
    this.querySearch();
  },
  methods: {
    confirmInput(){
      wmsApi.$asyncupdateLogisticsNo(this.tempInput).then((res) => {
        if (res.data.errno === 0) {
          this.$message.success("录入成功");
          this.isShowInput = false;
          this.querySearch();
        } else {
          this.$message.error(res.data.errmsg);
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    toInput(row) {
      this.isShowInput = true;
      this.tempInput.orderId = row.id;
    },
    goRefund(row){
      this.showRefund=true;
      this.refundForm={
        orderId:row.id,
        reason:'',
        refundAmount:row.payAmount,
        payAmount:row.payAmount,
        fraId:row.fraId
      }
      console.log(this.refundForm);
    },
    confirmRefund(){
      if(this.refundForm.refundAmount==0||this.refundForm.refundAmount>this.refundForm.payAmount){
        this.$message.warning("退款金额不能为0或大于支付金额");
        return;
      }
      if(this.refundForm.reason==null||this.refundForm.reason==''){
        this.$message.warning("退款原因不能为空");
        return;
      }
      
      wmsApi.$axiosWmsjmsOrderRefund(this.refundForm).then((res) => {
        if (res.data.errno === 0) {
            this.$message.success("退款成功");
            this.showRefund = false;
            this.querySearch(); 
        } else {
          this.$message.error(res.msg);
        }
      }).catch((err) => {
        this.$message.error(err);
      });
    },
    toBatchRebuy() {
      console.log("批量重买,value?" + JSON.stringify(this.orderForm));
      wmsApi.$asyncBatchRebuy(this.orderForm).then((res) => {
        if (res.data.errno === 0) {
          if (res.data.data&&res.data.data.length>0) {
            this.$message.warning("批量重买失败,请查看失败列表");
            this.rebuyFailLis = res.data.data;
          } else {
            this.$message.success("批量重买成功");
            this.isShowRebuy = false;
            this.querySearch();
          }

        } else {
          this.$message.error(res.msg);
        }
      }).catch((err) => {
        this.$message.error(err);
      });
    },
    batchRebuyPre(orderId) {
      this.isShowRebuy = true;
      this.orderForm.orderId = orderId;
    },
    orderExport() {
      let params = "/wmsOrder/listExport?token="
        + window.localStorage.getItem("token")
      window.open(url.salaryUrl + params);
    },
    toHandleShipment(row) {
      this.$router.push({
        path: "/warehouseCenter/dispatchCenter/handleShipment",
        query: {
          orderNo: row.orderNo,
        },
      });

    },
    addOrder() {
      this.$refs.addOrderFormRef.addOrder();
    },
    auditRefund(row) {
      this.isShowAudit = true;
      this.tempRow = row;
      this.applyAuditForm = {
        orderId: row.id,
        auditStatus: 1,
        auditRemark: "",
      };
      wmsApi
        .$axioswmsOrdergetOrderInfo({orderId: row.id})
        .then((res) => {
          this.orderInfo = res.data.data;

        })
        .catch((err) => {
          console.log(err);
        });
    },
    judgeOrderRefund() {
      if (this.orderInfo.order.orderStatus === 4) {
        console.log(globalData);
        console.log(globalData.userInfo.id);
        this.applyAuditForm.userId = globalData.userInfo.id;
        const temp = this.applyAuditForm;
        wmsApi.$axioswxOrderRefund(temp).then((res) => {
          if (res.data.errno == 0) {
            console.log("111")
            this.isShowAudit = false;
            this.$message.success("审核完成");
            this.querySearch();
          } else {
            this.$message.error(res.data.errmsg);
          }
        }).catch((err) => {
          console.log(err);
        });
      } else {
        this.$message({
          message: "订单状态不是待退款",
          type: "warning",
        });
      }
    },
    toCancel(row) {
      this.isShowCancel = true;
      this.tempRow = row;
      this.cancelData = {
        orderId: row.id,
        cancelReason: null,
      };
    },
    confirmCancelPay() {
      wmsApi
        .$axioswmsOrdercancelOrder(this.cancelData)
        .then((res) => {
          if (res.data.errno == 0) {
            this.$message.success("操作成功");
            this.isShowCancel = false;
            this.querySearch();
          } else {
            this.$message.error(res.data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    toPay(row) {
      this.isShowPay = true;
      this.tempRow = row;
      this.payData = {
        orderId: row.id,
        payType: null,
      };
    },
    confirmPay() {
      if (this.payData.payType == null || this.payData.payType == "") {
        this.$message.error("选择支付类型");
        return;
      }

      wmsApi
        .$axioswmsOrderpayOrder(this.payData)
        .then((res) => {
          if (res.data.errno == 0) {
            this.$message.success("操作成功");
            this.isShowPay = false;
            this.querySearch();
          } else {
            this.$message.error(res.data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    toInfo(row) {
      this.orderDetailList = [];
      if (row.orderNo.startsWith("FRA")) {
        wmsApi
          .$axioswmsOrdergetOrderInfo({orderId: row.id})
          .then((res) => {
            this.orderDetailList = res.data.data.goodsList;
          })
          .catch((err) => {
            console.log(err);
          });
      }else{
        if (row.orderSnapshot != null && row.orderSnapshot != "") {
          this.orderDetailList = JSON.parse(row.orderSnapshot).detail;
        }
      }


      this.isShowDetail = true;
      this.tempRow = row;
    },
    querySearch() {
      console.log(this.listQuery.createTime);
      if (this.listQuery.createTime.length > 0) {
        this.listQuery.startTime =
          this.listQuery.createTime[0] + " 00:00:00";
        this.listQuery.endTime =
          this.listQuery.createTime[1] + " 23:59:59";
      } else {
        this.listQuery.startTime = null;
        this.listQuery.endTime = null;
      }

      wmsApi
        .$axioswmsOrdergetOrderList(this.listQuery)
        .then((res) => {
          this.listData = res.data.data.list;
          this.total = res.data.data.total;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getAllStationList() {
      let cityidlist = globalData.userCityDataList != null ? globalData.userCityDataList : [];
      wmsApi
        .$axiosCityStationGetAll({})
        .then((res) => {
          // this.cityList = res.data.data;
          let templist = [];
          res.data.data.forEach(e => {
              if ( e.id !='0') {
                templist.push(e);
              }
          })
          this.cityList = templist;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    cityChange2(value) {
      this.listQuery.stationId = null;
      let currentStation = this.cityList.filter((item) => {
        return item.id == value;
      });
      if (currentStation == null || currentStation == '') {
        this.queryStationList = null;
      } else {
        this.queryStationList = currentStation[0].stationList;
      }
    },
    cityChange(value) {
      this.orderForm.stationId = "";
      let currentStation = this.cityList.filter((item) => {
        return item.id == value;
      });

      if (currentStation.length > 0) {
        this.stationList2 = currentStation[0].stationList;
      } else {
        this.stationList2 = [];
        return;
      }
      this.orderForm.workerNo = "";
      Service.$axiosGetWorkerList({
        cityId: this.orderForm.cityId,
      })
        .then((res) => {
          this.workerList = res.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    stationChange2(value) {
      this.orderForm.workerNo = "";
      if (value != null) {
        Service.$axiosGetWorkerList({
          cityId: this.orderForm.cityId,
          stationId: this.orderForm.stationId,
        })
          .then((res) => {
            this.workerList = res.data.data;
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
  },
};
</script>
